import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

export const LogoMark = ({ className = "w-8 h-8 text-[#0b2545]" }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="16" cy="16" r="11" stroke="#d4af37" strokeWidth="1" strokeDasharray="2 2" />
    <path d="M16 6v20M12 11c2 1 4 4 4 7M20 11c-2 1-4 4-4 7M11 16c2.5 1 5 3.5 5 7M21 16c-2.5 1-5 3.5-5 7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="16" cy="6" r="1.5" fill="#d4af37" />
  </svg>
);

const LINKS = [
  { href: "/#storia", label: "Chi Siamo", testid: "nav-link-chi-siamo" },
  { to: "/prodotti", label: "Assortimento", testid: "nav-link-assortimento" },
  { href: "/#vision", label: "Vision", testid: "nav-link-vision" },
  { href: "/#contatti", label: "Contatti", testid: "nav-link-contatti" },
];

export const anchor = (href) => {
  const id = href.split("#")[1];
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.location.href = href;
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav data-testid="main-nav" className="sticky top-0 z-50 bg-[#faf8f5]/90 backdrop-blur-md border-b border-[#0b2545]/10 px-6 py-4">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/images/logo.png" alt="Dahmani Food" className="w-11 h-11 rounded-xl shadow-sm" />
          <div className="flex flex-col">
            <span className="font-display font-bold text-xl tracking-wide text-[#0b2545] leading-none">DAHMANI</span>
            <span className="text-[9px] uppercase tracking-[0.25em] text-[#c59b27] font-semibold mt-0.5">Food · Halal Ingrosso</span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-xs font-semibold tracking-wider uppercase text-[#0b2545]/80">
          {LINKS.map((l) =>
            l.to ? (
              <Link key={l.to} to={l.to} data-testid={l.testid} className="hover:text-[#0b2545] transition-colors uppercase tracking-wider">
                {l.label}
              </Link>
            ) : (
              <button key={l.href} data-testid={l.testid} onClick={() => anchor(l.href)} className="hover:text-[#0b2545] transition-colors uppercase tracking-wider">
                {l.label}
              </button>
            )
          )}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/prodotti"
            data-testid="nav-cta-prodotti"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0b2545] text-white text-xs font-semibold uppercase tracking-wider hover:bg-[#d4af37] hover:text-[#06152d] transition-colors duration-300 shadow-sm"
          >
            <span>Prodotti</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-[#0b2545]"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden mt-4 pb-2 flex flex-col gap-1 border-t border-[#0b2545]/10 pt-4">
          {LINKS.map((l) =>
            l.to ? (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-sm font-semibold uppercase tracking-wider text-[#0b2545]/80 hover:text-[#0b2545] hover:bg-[#f0ebe1] rounded-lg transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <button
                key={l.href}
                data-testid={`${l.testid}-mobile`}
                onClick={() => { setOpen(false); anchor(l.href); }}
                className="text-left px-2 py-3 text-sm font-semibold uppercase tracking-wider text-[#0b2545]/80 hover:text-[#0b2545] hover:bg-[#f0ebe1] rounded-lg transition-colors"
              >
                {l.label}
              </button>
            )
          )}
          <Link
            to="/prodotti"
            data-testid="nav-cta-prodotti-mobile"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-[#0b2545] text-white text-xs font-semibold uppercase tracking-wider"
          >
            Prodotti <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      )}
    </nav>
  );
}
